// extracted by mini-css-extract-plugin
module.exports = {"base":"_2MDvcZ","buttonWrap":"-l4uGr","button":"_18qINm"};